// 轻量 toast: 底部居中黑底提示, 2s 自动淡出 — 高频操作反馈不打断操作流 (window.alert 会).

let timer: number | undefined;

export function toast(msg: string): void {
    let el = document.getElementById('_toast');
    if (!el) {
        el = document.createElement('div');
        el.id = '_toast';
        el.style.cssText =
            'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);' +
            'background:#1e293b;color:#fff;padding:9px 18px;border-radius:8px;' +
            'font-size:13px;z-index:99;box-shadow:0 6px 20px rgba(0,0,0,.18);' +
            'transition:opacity .2s;pointer-events:none';
        document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    if (timer !== undefined) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
        el.style.opacity = '0';
    }, 2000);
}
